import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })

export class HttpErrorInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private toastr: ToastrService
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(':: Interceptor Star');
    return next.handle(request)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          // console.log(':: HttpErrorResponse =>', err.status);
          if (err.status === 401) {
            // console.log(':: Error authorize 401');
            // auto logout if 401 response returned from api

            localStorage.removeItem('permissions');
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            this.router.navigate(['/account/login']);
          }
          else {
            // console.log(err);
            let error = '';

            if (err.error) {
              error = err.error.message || err.statusText;
              // console.log(':::: err =>', err.error);
              if (err.error && err.error.message === 'Modelo no válido' && err.error.data && Array.isArray(err.error.data)) {
                err.error.data.forEach((errorItem: any) => {
                  this.toastr.error(`Campo [${errorItem.field}] ${errorItem.description} `, environment.appName);
                });

              }
              else if (err.error && err.error.result) {
                this.toastr.error(`${err.error.result}`, environment.appName)
              }
              else if (error) {
                this.toastr.error(`${error}`, environment.appName)
              }
              else {
                this.toastr.error(`Ocurrió un error al procesar la solicitud: ${JSON.stringify(err)}`, environment.appName)
              }
            }
            return throwError(error);
          }
        })
      );
  }

}
